/* ===========================================================================
   tq-addons.js — Turqwaz.com
   Product-page add-ons ("Complete your set").

   • Add-ons are shown in boxes. Every box is MANDATORY and holds exactly
     one choice — the shopper cannot buy the main product on its own.
   • Accessories are split by TYPE into separate boxes: cisterns / flush
     tanks in one, seats & covers in another.
       – When the accessory is its own product, its TAGS (and product type)
         decide the box: "Flush Tanks" / "grp-flush-tanks" / "Concealed
         Cistern" → tank box, "Toilet Seats" / "Seats & Covers" → cover box.
       – When the accessory is a variant of the main product (no tags of its
         own), the accessory's name decides the box.
   • The cheapest buyable option in each box is picked by default, and the
     running total always shows what the shopper will actually pay.
   • Previews (image, price, stock) follow the main product's selected
     colour and size.
   • On Add-to-cart the chosen add-ons go in as their own line items.

   No dependencies. Loaded by snippets/product-addons.liquid.
   ======================================================================== */
(function () {
  'use strict';

  if (window.__tqAddonsLoaded) return;
  window.__tqAddonsLoaded = true;

  var CFG = {
    COLOUR_NAMES: ['color', 'colour', 'اللون', 'لون'],
    SIZE_NAMES: ['size', 'المقاس', 'مقاس', 'الحجم'],
    BASE_HINTS: ['only', 'alone', 'فقط'],
    MATCH_MAIN_QUANTITY: true,
    HIDE_DYNAMIC_CHECKOUT: true,

    /* --- one required box per accessory type ------------------------------ */
    GROUP_ORDER: ['tank', 'cover', 'other'],

    /* tags / product types — used first whenever the add-on is its own product */
    GROUP_TANK_TAGS: [
      'flush tank', 'flush tanks', 'grp-flush-tanks', 'cistern', 'cisterns',
      'concealed cistern', 'grp-concealed-bodies', 'tank', 'tanks',
      'خزان', 'خزانات', 'صندوق طرد', 'صندوق الطرد'
    ],
    GROUP_COVER_TAGS: [
      'toilet seat', 'toilet seats', 'seat & cover', 'seats & covers',
      'seats and covers', 'cover', 'covers', 'lid', 'lids',
      'مقعد', 'مقاعد', 'غطاء', 'أغطية', 'اغطية'
    ],

    /* name words — used when the add-on has no tags of its own */
    GROUP_COVER_FIRST: ['seat', 'مقعد', 'كرسي'],
    GROUP_TANK: [
      'cistern', 'tank', 'flush box', 'flushing box', 'concealed tank',
      'خزان', 'الخزان', 'سيفون', 'صندوق طرد', 'صندوق الطرد'
    ],
    GROUP_COVER: [
      'cover', 'lid', 'seat', 'toilet seat',
      'غطاء', 'الغطاء', 'كفر', 'مقعد'
    ],
    GROUP_TITLES_EN: {
      tank: 'Choose your cistern',
      cover: 'Choose your seat & cover',
      other: 'Choose your extra'
    },
    GROUP_TITLES_AR: {
      tank: 'اختر الخزان',
      cover: 'اختر المقعد والغطاء',
      other: 'اختر الإضافة'
    }
  };

  /* ------------------------------------------------------------ helpers */
  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function isArabic() {
    var lang = norm(document.documentElement.lang || '');
    return lang.indexOf('ar') === 0;
  }

  function sameOptions(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (norm(a[i]) !== norm(b[i])) return false;
    return true;
  }

  function withCommas(n, decimals) {
    var parts = n.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function formatMoney(cents, cfg) {
    var fmt = cfg.moneyFormat || '';
    var value = (cents || 0) / 100;
    if (fmt && /\{\{\s*\w+\s*\}\}/.test(fmt)) {
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
        switch (token) {
          case 'amount_no_decimals':
          case 'amount_no_decimals_with_comma_separator':
            return withCommas(value, 0);
          case 'amount_with_apostrophe_separator':
            return withCommas(value, 2).replace(/,/g, "'");
          default:
            return withCommas(value, 2);
        }
      });
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: cfg.currency || 'USD'
      }).format(value);
    } catch (e) {
      return withCommas(value, 2);
    }
  }

  /* ------------------------------------------------------------ the widget */
  function AddOns(root) {
    this.root = root;
    this.uid = root.id || 'pa';
    this.listEl = root.querySelector('[data-pa-list]');
    this.totalsEl = root.querySelector('[data-pa-totals]');
    this.pick = Object.create(null);   // groupId -> item key
    this.groupState = [];

    var raw = root.querySelector('[data-pa-config]');
    if (!raw) return;
    try {
      this.cfg = JSON.parse(raw.textContent);
    } catch (e) {
      console.warn('[tq-addons] bad config JSON', e);
      return;
    }

    this.form = this.findForm();
    if (!this.form) return;

    this.parent = this.cfg.parent;
    this.baseValue = this.resolveBaseValue();
    this.addonIndex = this.parent.addonOptionIndex;
    this.requireEach = this.cfg.strings.requireEach !== false;

    root.querySelector('[data-pa-heading]').textContent = this.cfg.strings.heading;
    root.querySelector('[data-pa-subheading]').textContent = this.cfg.strings.subheading;

    this.hideAddonOptionSelector();
    this.forceBaseSelection();
    this.bind();
    this.render();
  }

  AddOns.prototype.findForm = function () {
    var scope = this.root.closest('[data-section], section, .shopify-section') || document;
    return (
      scope.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  };

  /** Which value of the add-on option means "the product on its own". */
  AddOns.prototype.resolveBaseValue = function () {
    if (this.parent.baseValue) return this.parent.baseValue;
    var idx = this.parent.addonOptionIndex;
    if (idx < 0) return null;
    var values = [];
    this.parent.variants.forEach(function (v) {
      var val = v.options[idx];
      if (val && values.indexOf(val) === -1) values.push(val);
    });
    for (var i = 0; i < values.length; i++) {
      var lower = norm(values[i]);
      for (var j = 0; j < CFG.BASE_HINTS.length; j++) {
        if (lower.indexOf(CFG.BASE_HINTS[j]) !== -1) return values[i];
      }
    }
    return values[0] || null;
  };

  /* --------------------------------------------- current parent variant */
  AddOns.prototype.idInput = function () {
    return this.form.querySelector('[name="id"]');
  };

  AddOns.prototype.currentVariant = function () {
    var input = this.idInput();
    var id = input ? parseInt(input.value, 10) : NaN;
    var found = null;
    this.parent.variants.forEach(function (v) { if (v.id === id) found = v; });
    return found || this.parent.variants[0] || null;
  };

  AddOns.prototype.baseVariant = function () {
    var current = this.currentVariant();
    if (!current) return null;
    if (this.addonIndex < 0 || !this.baseValue) return current;
    if (norm(current.options[this.addonIndex]) === norm(this.baseValue)) return current;

    var wanted = current.options.slice();
    wanted[this.addonIndex] = this.baseValue;
    var match = null;
    this.parent.variants.forEach(function (v) {
      if (!match && sameOptions(v.options, wanted)) match = v;
    });
    return match || current;
  };

  /* ------------------------------------------- hide the accessory picker */
  AddOns.prototype.hideAddonOptionSelector = function () {
    if (this.addonIndex < 0) return;
    var idx = this.addonIndex;
    var values = [];
    this.parent.variants.forEach(function (v) {
      var val = v.options[idx];
      if (val && values.indexOf(norm(val)) === -1) values.push(norm(val));
    });

    var controls = this.form.querySelectorAll('input[type="radio"], select, input[type="hidden"][data-option]');
    var groups = [];
    Array.prototype.forEach.call(controls, function (el) {
      var candidates = el.tagName === 'SELECT'
        ? Array.prototype.map.call(el.options, function (o) { return norm(o.value); })
        : [norm(el.value)];
      var hits = candidates.filter(function (c) { return values.indexOf(c) !== -1; }).length;
      if (hits && hits === candidates.length) {
        var wrapper =
          el.closest('fieldset') ||
          el.closest('.product-form__input') ||
          el.closest('[class*="option"]') ||
          el.parentElement;
        if (wrapper && groups.indexOf(wrapper) === -1) groups.push(wrapper);
      }
    });
    groups.forEach(function (g) { g.classList.add('pa-hidden-option'); });
    this.optionGroups = groups;
  };

  /** Landed on an accessory variant? Snap back to the base variant and
   *  pre-select that accessory in its add-on box instead. */
  AddOns.prototype.forceBaseSelection = function () {
    if (this.addonIndex < 0 || !this.baseValue) return;
    var current = this.currentVariant();
    if (!current) return;
    var landedOn = current.options[this.addonIndex];
    if (norm(landedOn) === norm(this.baseValue)) return;
    this.pendingPreselect = landedOn;
    this.selectOptionValue(this.baseValue);
  };

  AddOns.prototype.selectOptionValue = function (value) {
    var target = norm(value);
    var radios = this.form.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (norm(radios[i].value) === target) {
        radios[i].checked = true;
        radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        radios[i].dispatchEvent(new Event('input', { bubbles: true }));
        return true;
      }
    }
    var selects = this.form.querySelectorAll('select');
    for (var s = 0; s < selects.length; s++) {
      var opts = selects[s].options;
      for (var o = 0; o < opts.length; o++) {
        if (norm(opts[o].value) === target) {
          selects[s].selectedIndex = o;
          selects[s].dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }
    return false;
  };

  /* ------------------------------------------------- build the add-on set */
  AddOns.prototype.sameProductAddons = function (current) {
    var out = [];
    if (this.addonIndex < 0 || !current) return out;
    var idx = this.addonIndex;
    var self = this;

    var values = [];
    this.parent.variants.forEach(function (v) {
      var val = v.options[idx];
      if (val && norm(val) !== norm(self.baseValue) && values.indexOf(val) === -1) {
        values.push(val);
      }
    });

    values.forEach(function (value) {
      var wanted = current.options.slice();
      wanted[idx] = value;
      var match = null;
      self.parent.variants.forEach(function (v) {
        if (!match && sameOptions(v.options, wanted)) match = v;
      });
      out.push({
        key: 'p' + self.parent.id + ':' + value,
        label: value,
        variant: match,
        exists: !!match,
        url: null,
        tags: [],          // a variant of the main product carries no tags
        type: ''
      });
    });
    return out;
  };

  AddOns.prototype.linkedAddons = function (current) {
    var out = [];
    var linked = this.cfg.linked || [];
    if (!linked.length || !current) return out;

    var parentNames = this.parent.optionNames.map(norm);

    function parentValueFor(names) {
      for (var i = 0; i < parentNames.length; i++) {
        if (names.indexOf(parentNames[i]) !== -1) return current.options[i];
      }
      return null;
    }
    var wantColour = parentValueFor(CFG.COLOUR_NAMES);
    var wantSize = parentValueFor(CFG.SIZE_NAMES);

    linked.forEach(function (prod) {
      var names = (prod.optionNames || []).map(norm);
      var colourIdx = -1, sizeIdx = -1;
      names.forEach(function (n, i) {
        if (CFG.COLOUR_NAMES.indexOf(n) !== -1) colourIdx = i;
        if (CFG.SIZE_NAMES.indexOf(n) !== -1) sizeIdx = i;
      });

      function pick(useColour, useSize, requireAvailable) {
        var hit = null;
        prod.variants.forEach(function (v) {
          if (hit) return;
          if (requireAvailable && !v.available) return;
          if (useColour && colourIdx > -1 && wantColour &&
              norm(v.options[colourIdx]) !== norm(wantColour)) return;
          if (useSize && sizeIdx > -1 && wantSize &&
              norm(v.options[sizeIdx]) !== norm(wantSize)) return;
          hit = v;
        });
        return hit;
      }

      var variant =
        pick(true, true, true) || pick(true, true, false) ||
        pick(true, false, true) || pick(true, false, false);

      var matchedColour = !!variant && (colourIdx === -1 || !wantColour ||
        norm(variant.options[colourIdx]) === norm(wantColour));

      out.push({
        key: 'l' + prod.id,
        label: prod.title,
        variant: variant,
        exists: !!variant && matchedColour,
        url: prod.url,
        tags: prod.tags || [],   // the accessory product's own tags
        type: prod.type || ''
      });
    });
    return out;
  };

  /* ------------------------------------------- one box per accessory type */
  AddOns.prototype.groupRules = function () {
    if (this._rules) return this._rules;

    var g = this.cfg.groups || {};
    var s = this.cfg.strings || {};
    var fallbackTitles = isArabic() ? CFG.GROUP_TITLES_AR : CFG.GROUP_TITLES_EN;

    function words(value, fallback) {
      if (typeof value === 'string') value = value.split(',');
      if (!Array.isArray(value)) return fallback;
      var cleaned = value.map(norm).filter(Boolean);
      return cleaned.length ? cleaned : fallback;
    }

    this._rules = {
      enabled: g.enabled !== false,
      order: CFG.GROUP_ORDER,
      tankTags: words(g.tankTags, CFG.GROUP_TANK_TAGS),
      coverTags: words(g.coverTags, CFG.GROUP_COVER_TAGS),
      coverFirst: CFG.GROUP_COVER_FIRST,
      tank: words(g.tankKeywords, CFG.GROUP_TANK),
      cover: words(g.coverKeywords, CFG.GROUP_COVER),
      titles: {
        tank: g.tankTitle || fallbackTitles.tank,
        cover: g.coverTitle || fallbackTitles.cover,
        other: g.otherTitle || s.optionGroupTitle || this.parent.addonOption || fallbackTitles.other
      }
    };
    return this._rules;
  };

  /** tank | cover | other.
   *  Tags (and product type) decide it whenever the accessory is its own
   *  product; otherwise the accessory's own name does. */
  AddOns.prototype.categorise = function (item, rules) {
    var label = norm(item && item.label);
    var tags = ((item && item.tags) || []).map(norm);
    if (item && item.type) tags.push(norm(item.type));

    function tagHit(list) {
      for (var i = 0; i < tags.length; i++) {
        for (var j = 0; j < list.length; j++) {
          if (list[j] && tags[i].indexOf(list[j]) !== -1) return true;
        }
      }
      return false;
    }
    function textHit(list) {
      for (var k = 0; k < list.length; k++) {
        if (list[k] && label.indexOf(list[k]) !== -1) return true;
      }
      return false;
    }

    if (tags.length) {
      if (tagHit(rules.coverTags)) return 'cover';
      if (tagHit(rules.tankTags)) return 'tank';
    }
    if (textHit(rules.coverFirst)) return 'cover';
    if (textHit(rules.tank)) return 'tank';
    if (textHit(rules.cover)) return 'cover';
    return 'other';
  };

  /** The add-on boxes. Each box is one mandatory choice. */
  AddOns.prototype.buildGroups = function (current) {
    var self = this;
    var s = this.cfg.strings;
    var out = [];
    var rules = this.groupRules();
    var items = this.sameProductAddons(current).concat(this.linkedAddons(current));

    if (!items.length) return out;

    if (!rules.enabled) {
      var opt = items.filter(function (it) { return it.key.charAt(0) === 'p'; });
      var ext = items.filter(function (it) { return it.key.charAt(0) === 'l'; });
      if (opt.length) {
        out.push({
          id: 'opt',
          title: s.optionGroupTitle || this.parent.addonOption || s.heading,
          items: opt
        });
      }
      if (ext.length) {
        out.push({ id: 'extras', title: s.extrasGroupTitle || s.heading, items: ext });
      }
      return out;
    }

    var buckets = {};
    items.forEach(function (it) {
      var id = self.categorise(it, rules);
      (buckets[id] = buckets[id] || []).push(it);
    });

    var ids = rules.order.filter(function (id) {
      return buckets[id] && buckets[id].length;
    });

    if (ids.length > 1) {
      ids.forEach(function (id) {
        var title = id === 'other'
          ? (rules.titles.other || s.extrasGroupTitle || s.heading)
          : rules.titles[id];
        out.push({ id: 'opt-' + id, title: title, items: buckets[id] });
      });
    } else if (ids.length === 1) {
      out.push({
        id: 'opt',
        title: rules.titles[ids[0]] || s.optionGroupTitle || this.parent.addonOption || s.heading,
        items: buckets[ids[0]]
      });
    }
    return out;
  };

  /* --------------------------------------------------------------- render */
  AddOns.prototype.render = function () {
    var current = this.currentVariant();
    var base = this.baseVariant();
    if (!current || !base) return;

    var groups = this.buildGroups(current);
    if (!groups.length) {
      this.root.hidden = true;
      this.root.classList.remove('pa--grouped');
      this.groupState = [];
      return;
    }
    this.root.hidden = false;
    this.root.classList.toggle('pa--grouped', groups.length > 1);

    var self = this;
    var cfg = this.cfg;

    groups.forEach(function (g) {
      g.buyable = g.items.filter(function (it) {
        return it.exists && it.variant && it.variant.available;
      });
      g.required = self.requireEach && g.buyable.length > 0;

      var cur = self.pick[g.id];
      var valid = !!cur && g.buyable.some(function (it) { return it.key === cur; });

      if (!valid && self.pendingPreselect) {
        var want = norm(self.pendingPreselect);
        g.buyable.forEach(function (it) {
          if (!valid && norm(it.label) === want) { self.pick[g.id] = it.key; valid = true; }
        });
      }
      if (!valid) {
        delete self.pick[g.id];
        if (g.required) {
          var cheapest = g.buyable.slice().sort(function (a, b) {
            return a.variant.price - b.variant.price;
          })[0];
          if (cheapest) self.pick[g.id] = cheapest.key;
        }
      }
    });
    this.pendingPreselect = null;

    var baseImg = base.image || '';
    var baseAlt = this.parent.title;

    var html = groups.map(function (g) {
      var cards = g.items.map(function (it) {
        var v = it.variant;
        var buyable = it.exists && v && v.available;
        var checked = buyable && self.pick[g.id] === it.key;
        var addImg = (v && v.image) || '';
        var price = v ? formatMoney(v.price, cfg) : '';

        var combo =
          '<span class="pa__combo">' +
            (baseImg
              ? '<img class="pa__combo-img" src="' + baseImg + '" alt="' + esc(baseAlt) + '" loading="lazy">'
              : '<span class="pa__combo-img pa__combo-img--empty"></span>') +
            '<span class="pa__plus" aria-hidden="true">+</span>' +
            (addImg
              ? '<img class="pa__combo-img" src="' + addImg + '" alt="' + esc(it.label) + '" loading="lazy">'
              : '<span class="pa__combo-img pa__combo-img--empty"></span>') +
          '</span>';

        return (
          '<li class="pa__item' + (buyable ? '' : ' is-disabled') + (checked ? ' is-checked' : '') + '">' +
            '<label class="pa__label">' +
              '<input type="radio" class="pa__cb"' +
                ' name="tqpa-' + esc(self.uid) + '-' + esc(g.id) + '"' +
                ' data-pa-group="' + esc(g.id) + '" data-pa-key="' + esc(it.key) + '"' +
                (checked ? ' checked' : '') + (buyable ? '' : ' disabled') +
                ' aria-label="' + esc(it.label) + '">' +
              '<span class="pa__box" aria-hidden="true"></span>' +
              combo +
              '<span class="pa__text">' +
                (buyable
                  ? '<span class="pa__price">+ ' + price + '</span>'
                  : '<span class="pa__oos">' + esc(cfg.strings.unavailable) + '</span>') +
                '<span class="pa__name">' + esc(it.label) + '</span>' +
              '</span>' +
            '</label>' +
          '</li>'
        );
      }).join('');

      return (
        '<div class="pa__group" data-pa-group-id="' + esc(g.id) + '">' +
          '<div class="pa__group-head">' +
            '<span class="pa__group-title">' + esc(g.title) + '</span>' +
            (g.required ? '<span class="pa__req">' + esc(cfg.strings.requiredLabel) + '</span>' : '') +
          '</div>' +
          '<ul class="pa__list" role="radiogroup" aria-label="' + esc(g.title) + '">' + cards + '</ul>' +
          '<p class="pa__group-msg" data-pa-group-msg hidden>' + esc(cfg.strings.requiredMsg) + '</p>' +
        '</div>'
      );
    }).join('');

    this.listEl.innerHTML = html;
    this.groupState = groups;
    this.renderTotals(base, groups);
    this.toggleDynamicCheckout();
  };

  AddOns.prototype.quantity = function () {
    if (!CFG.MATCH_MAIN_QUANTITY) return 1;
    var q = this.form.querySelector('[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  };

  AddOns.prototype.chosen = function (groups) {
    var self = this, out = [];
    (groups || this.groupState || []).forEach(function (g) {
      var key = self.pick[g.id];
      if (!key) return;
      g.items.forEach(function (it) {
        if (it.key === key && it.exists && it.variant && it.variant.available) out.push(it);
      });
    });
    return out;
  };

  AddOns.prototype.missingGroups = function () {
    var self = this;
    return (this.groupState || []).filter(function (g) {
      return g.required && !self.pick[g.id];
    });
  };

  /* --------------------------------------------------------------- totals */
  AddOns.prototype.renderTotals = function (base, groups) {
    var cfg = this.cfg;
    var qty = this.quantity();
    var picked = this.chosen(groups);

    if (!picked.length) {
      this.totalsEl.innerHTML = '';
      this.totalsEl.hidden = true;
      return;
    }
    this.totalsEl.hidden = false;

    var total = base.price * qty;
    var rows = [
      '<div class="pa__row">' +
        '<span>' + esc(cfg.strings.basePrice) + (qty > 1 ? ' × ' + qty : '') + '</span>' +
        '<span>' + formatMoney(base.price * qty, cfg) + '</span>' +
      '</div>'
    ];
    picked.forEach(function (it) {
      total += it.variant.price * qty;
      rows.push(
        '<div class="pa__row">' +
          '<span>+ ' + esc(it.label) + (qty > 1 ? ' × ' + qty : '') + '</span>' +
          '<span>' + formatMoney(it.variant.price * qty, cfg) + '</span>' +
        '</div>'
      );
    });
    rows.push(
      '<div class="pa__row pa__row--total">' +
        '<span>' + esc(cfg.strings.total) + '</span>' +
        '<span data-pa-grand>' + formatMoney(total, cfg) + '</span>' +
      '</div>'
    );
    if (cfg.strings.showBundleCta) {
      rows.push(
        '<button type="button" class="pa__bundle-btn" data-pa-bundle>' +
          esc(cfg.strings.bundleCta) +
        '</button>'
      );
    }
    this.totalsEl.innerHTML = rows.join('');
  };

  AddOns.prototype.toggleDynamicCheckout = function () {
    if (!CFG.HIDE_DYNAMIC_CHECKOUT) return;
    var hide = (this.groupState || []).length > 0;
    var btns = this.form.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]');
    Array.prototype.forEach.call(btns, function (b) {
      b.classList.toggle('pa-hidden-option', hide);
    });
  };

  /* -------------------------------------------------------------- binding */
  AddOns.prototype.bind = function () {
    var self = this;

    this.totalsEl.addEventListener('click', function (e) {
      if (!e.target.closest('[data-pa-bundle]')) return;
      var addBtn = self.form.querySelector('[name="add"], [type="submit"]');
      if (addBtn) addBtn.click();
    });

    this.listEl.addEventListener('change', function (e) {
      var cb = e.target.closest('.pa__cb');
      if (!cb) return;
      self.pick[cb.dataset.paGroup] = cb.dataset.paKey;
      self.render();
    });

    this.form.addEventListener('change', function (e) {
      if (e.target.closest('[data-pa-list]')) return;
      setTimeout(function () { self.render(); }, 0);
    });

    var last = this.idInput() ? this.idInput().value : null;
    setInterval(function () {
      var input = self.idInput();
      if (!input) return;
      if (input.value !== last) {
        last = input.value;
        self.render();
      }
    }, 250);

    this.form.addEventListener('submit', function (e) { self.onAdd(e); }, true);
    var addBtn = this.form.querySelector('[name="add"], [type="submit"]');
    if (addBtn) addBtn.addEventListener('click', function (e) { self.onAdd(e); }, true);
  };

  /* ------------------------------------------------------------ add to cart */
  AddOns.prototype.onAdd = function (e) {
    if (this._passthrough) { this._passthrough = false; return; }

    var missing = this.missingGroups();
    if (missing.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.flagMissing(missing);
      return;
    }

    var picked = this.chosen();
    if (!picked.length) return; // nothing extra — let the theme do its thing

    this._submitter =
      e.submitter ||
      (e.target && e.target.closest && e.target.closest('button, input[type="submit"]')) ||
      null;

    e.preventDefault();
    e.stopImmediatePropagation();

    var self = this;
    var qty = this.quantity();
    var items = picked.map(function (it) {
      return {
        id: it.variant.id,
        quantity: qty,
        properties: { _addon_for: self.parent.title }
      };
    });

    this.setBusy(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message); });
        return r.json();
      })
      .then(function () {
        self._passthrough = true;
        self.setBusy(false);
        self.resubmit();
      })
      .catch(function (err) {
        self.setBusy(false);
        self._submitter = null;
        console.error('[tq-addons] add failed', err);
        self.showError(err && err.message);
      });
  };

  AddOns.prototype.flagMissing = function (missing) {
    var self = this;
    var first = null;
    (this.groupState || []).forEach(function (g) {
      var el = self.listEl.querySelector('[data-pa-group-id="' + g.id + '"]');
      if (!el) return;
      var bad = missing.indexOf(g) !== -1;
      el.classList.toggle('is-missing', bad);
      var msg = el.querySelector('[data-pa-group-msg]');
      if (msg) msg.hidden = !bad;
      if (bad && !first) first = el;
    });
    if (first && first.scrollIntoView) {
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  AddOns.prototype.resubmit = function () {
    var btn = this._submitter || this.form.querySelector('[name="add"], [type="submit"]');
    this._submitter = null;
    if (btn && btn.type === 'submit' && this.form.requestSubmit) {
      this.form.requestSubmit(btn);
    } else if (btn) {
      btn.click();
    } else if (this.form.requestSubmit) {
      this.form.requestSubmit();
    } else {
      this.form.submit();
    }
  };

  AddOns.prototype.setBusy = function (state) {
    this.root.classList.toggle('is-busy', !!state);
    var btn = this.form.querySelector('[name="add"], [type="submit"]');
    if (btn) btn.toggleAttribute('aria-busy', !!state);
  };

  AddOns.prototype.showError = function (msg) {
    var el = this.root.querySelector('[data-pa-error]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'pa__error';
      el.setAttribute('data-pa-error', '');
      this.root.querySelector('[data-pa-inner]').appendChild(el);
    }
    el.textContent = msg || 'Sorry, that add-on could not be added.';
  };

  /* ----------------------------------------------------------------- boot */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-product-addons]').forEach(function (el) {
      if (el.__paInit) return;
      el.__paInit = true;
      try { new AddOns(el); } catch (err) { console.error('[tq-addons]', err); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();